export const settings = {
  setShareTitle: 'Поделиться приложением',
  setNotifiationsTitle: 'Уведомления',
  setContactAppOwnerTitle: 'Написать владельцу приложения',
  setContactDevelopersTitle: 'Написать разработчикам',
  setReportAppTitle: 'Пожаловаться на приложение',
  setDeleteAccountTitle: 'Удалить аккаунт',
  setLogOutTitle: 'Выйти',
  setShareAppCurtainTitle: 'Поделиться приложением',
  setShareAppCurtainButtonTitle: 'Скопировать ссылку',
  setShareAppAlertWhenAppLinkWasCopied: 'Ссылка скопирована!',
  setNotificationsInAppTitle: 'Внутренние',
  setNotificationsPushContent: 'Push',
  setNotificationsChatsTitle: 'Чаты',
  setNotificationsDiscussionsTitle: 'Обсуждения',
  setNotificationsNewsTitle: 'Лента новостей',
  setNotificationsEventsTitle: 'События',
  setNotificationsAdminTitle: 'Административные уведомления',
  setNotificationsBlogTitle: 'Блог',
  setNotificationsPushOffContent: 'Push-уведомления выключены',
  setNotificationsPushOffText:
    'Чтобы включить push-уведомления, перейдите в настройки вашего устройства/телефона и включите уведомления',
  setReportAppFlagCurtainTitle: 'Жалоба',
  setAppReportedCurtainContent: 'Жалоба отправлена',
  setDeleteCurtainTitle: 'Удалить аккаунт',
  setDeleteCurtainInputContent: 'Пароль',
  setDeleteCurtainCancelButtonTitle: 'Отмена',
  setDeleteCurtainConfirmButtonTitle: 'Подтвердить',
  setDeleteCurtainIncorrectPasswordAlertText: 'Неверный пароль',
  setTurnNotificationsOnText:
    'Чтобы включить уведомления, пожалуйста, нажмите на кнопку ниже и разрешите нам отправлять вам уведомления.',
  setTurnNotificationsOnButton: 'Включить push-уведомления',
  changeLanguage: 'Изменить язык приложения',
  changeLanguageAlertSuccess: 'Язык приложения успешно изменён'
}
